module.exports = __webpack_public_path__ + "img/icon-success-new.7403ae94.svg";